import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import Clock from "@/components/Clock";
import { School, UserCog, Users, Send } from "lucide-react";

const Stat = ({ icon: Icon, label, value, color }) => (
  <Card className="overflow-hidden">
    <CardContent className="flex items-center gap-4 p-5">
      <div className={`flex h-14 w-14 items-center justify-center rounded-2xl ${color}`}>
        <Icon className="h-7 w-7" />
      </div>
      <div>
        <p className="text-3xl font-extrabold text-slate-800">{value ?? "—"}</p>
        <p className="text-sm text-slate-400">{label}</p>
      </div>
    </CardContent>
  </Card>
);

export default function AdminDashboard() {
  const [stats, setStats] = useState({});
  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);
  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="text-2xl font-extrabold text-slate-800">لوحة المشرف العام</h1>
          <p className="text-slate-400">نظرة عامة على المنصة وجميع المدارس</p>
        </div>
        <Clock />
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <Stat icon={School} label="عدد المدارس" value={stats.schools} color="bg-emerald-100 text-emerald-700" />
        <Stat icon={UserCog} label="عدد المرشدين" value={stats.counselors} color="bg-teal-100 text-teal-700" />
        <Stat icon={Users} label="عدد الطلاب" value={stats.students} color="bg-sky-100 text-sky-700" />
        <Stat icon={Send} label="الرسائل المرسلة" value={stats.messages} color="bg-amber-100 text-amber-700" />
      </div>
      <Card>
        <CardContent className="flex items-center gap-4 p-5">
          <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-green-100 text-green-700">
            <School className="h-7 w-7" />
          </div>
          <div>
            <p className="text-3xl font-extrabold text-slate-800">{stats.active_schools ?? "—"}</p>
            <p className="text-sm text-slate-400">المدارس ذات الاشتراك الفعّال</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
